// ============================================
// COMPONENT - Confirmación al abrir caja con turnos antiguos abiertos
// ============================================
// El backend responde 409 TURNO_ANTIGUO_CONFIRMACION_REQUERIDA cuando el almacén tiene un turno abierto
// hace más de 3 días; el mensaje viene redactado desde el backend.

import { ConfirmacionModal } from '@/components/ConfirmacionModal';

interface ConfirmarTurnoAntiguoModalProps {
  /** Mensaje del backend; null = modal cerrado. */
  mensaje: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ConfirmarTurnoAntiguoModal = ({ mensaje, onConfirm, onCancel, isLoading }: ConfirmarTurnoAntiguoModalProps) => (
  <ConfirmacionModal
    isOpen={mensaje !== null}
    onClose={onCancel}
    onConfirm={onConfirm}
    title="Hay turnos de caja antiguos abiertos"
    message={mensaje ?? ''}
    confirmText="Abrir igual"
    cancelText="Cancelar"
    isLoading={isLoading}
    variant="warning"
  />
);
